<template>
    <b-modal id="modal-payroll" ref="modal-payroll" :title="titleModal" no-enforce-focus scrollable size="lg">
      <!-- Header Company -->
      <HeaderCompany :consecutive="payrollData.consecutive"/>
      <a-divider/>
      <b-row class="px-3">
        <b-col>
          <p>
            Total a pagar: {{ currencyFormat(payrollData.totals.totalPayment) }}
          </p>
        </b-col>
      </b-row>
      <!-- Tabs -->
      <b-row>
        <b-col>
            <a-tabs v-model="activeKey">
                <a-tab-pane key="1" tab="Fechas">
                    <b-row>
                        <b-col lg="6">
                            <validation-provider name="Inicio de liquidación" :rules="{ required: true }"
                            v-slot="validationContext">
                                <b-form-group id="payStartDate" label="Inicio de liquidación" label-for="payStartDate"
                                    :invalid-feedback="validationContext.errors[0]">
                                  <b-form-datepicker id="payStartDate" v-model="payrollData.payStartDate" type="date" required
                                        :state="getValidationState(validationContext)" locale="es"></b-form-datepicker>
                                        <!-- <input type="date" name="date" id="dt" v-model="payrollData.payStartDate">} -->
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="6">
                            <validation-provider name="Fin de liquidación" :rules="{ required: true }" v-slot="validationContext">
                                <b-form-group id="payEndDate" label="Fin de liquidación:" label-for="payEndDate"
                                :invalid-feedback="validationContext.errors[0]">
                                    <b-form-datepicker id="payEndDate" v-model="payrollData.payEndDate" type="date" required
                                    :state="getValidationState(validationContext)" :dropright="true" locale="es"></b-form-datepicker>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="6">
                            <validation-provider name="Pago de nómina" :rules="{ required: true }" v-slot="validationContext">
                                <b-form-group id="payDate" label="Pago de nómina:" label-for="payDate"
                                    :invalid-feedback="validationContext.errors[0]">
                                    <b-form-datepicker id="payDate" v-model="payrollData.payDate" type="date" required
                                    :state="getValidationState(validationContext)" locale="es"></b-form-datepicker>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="6">
                            <validation-provider name="Método de pago" :rules="{ required: true }" v-slot="validationContext">
                                <b-form-group id="paymentMethod" label="Método de pago:" label-for="paymentMethod"
                                    :invalid-feedback="validationContext.errors[0]">
                                    <b-form-select id="paymentMethod" v-model="payrollData.employee.idPaymentMethod"
                                    :options="paymentMethods" required
                                    :state="getValidationState(validationContext)"></b-form-select>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="6" v-show="isPaymentMethodWithBank">
                            <validation-provider name="Tipo de cuenta bancaria" :rules="{ required: true }" v-slot="validationContext">
                                <b-form-group id="bankAccountType" label="Tipo de cuenta bancaria" label-for="bankAccountType"
                                    :invalid-feedback="validationContext.errors[0]">
                                    <b-form-select id="bankAccountType" v-model="payrollData.employee.idBankAccountType"
                                    :options="bankAccountTypes" required
                                    :state="getValidationState(validationContext)"></b-form-select>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="6" v-show="isPaymentMethodWithBank">
                            <validation-provider name="Banco" :rules="{ required: true }" v-slot="validationContext">
                                <b-form-group id="bank" label="Banco" label-for="bank"
                                    :invalid-feedback="validationContext.errors[0]">
                                    <b-form-select id="bank" v-model="payrollData.employee.idBank"
                                    :options="banks" required
                                    :state="getValidationState(validationContext)"></b-form-select>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col lg="6" v-show="isPaymentMethodWithBank">
                            <validation-provider name="Número de cuenta" :rules="{ required: true }" v-slot="validationContext">
                                <b-form-group id="bankAccountNumber" label="Número de cuenta" label-for="bankAccountNumber"
                                    :invalid-feedback="validationContext.errors[0]">
                                    <b-form-input id="bankAccountNumber" v-model="payrollData.employee.bankAccountNumber"
                                    required
                                    :state="getValidationState(validationContext)"></b-form-input>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                </a-tab-pane>
                <a-tab-pane key="2" tab="Devengados">
                  <template>
                    <div class="px-4" fluid>
                      <b-row v-show="accrualsSelector.length > 1">
                        <b-col cols="9" md="7">
                          <b-form-group id="accruals" label="Devengados" label-for="accruals">
                            <b-form-select v-model="accrualCreated"
                            :options="accrualsSelector" required
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col class="pl-2" cols="2" md="3" align-self="end">
                          <b-button variant="primary" class="my-3 mx-2" @click="removeSelectedOption('accruals')">Agregar</b-button>
                        </b-col>
                      </b-row>
                      <b-table id="table-periods-payrolls" striped hover :fields="columns"
                        :items="payrollData.accruals" head-variant="light" responsive>
                        <template #cell(inputs)="accrual">
                          <b-col v-if="accrual.item.requireDays" :md="checkSize(accrual)">
                            <validation-provider
                              name="Días"
                              :rules="{ required: true, integer: true }"
                              v-slot="validationContext"
                            >
                              <b-form-group :id="`days-${accrual.item.idConcept}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                                <b-form-input :id="`accrual-days-${accrual.item.idConcept}`" v-model="accrual.item.days"
                                placeholder="Días *"
                                :state="getValidationState(validationContext)"
                                ></b-form-input>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                          <b-col v-if="accrual.item.requireHours" :md="checkSize(accrual)">
                            <validation-provider
                              name="Horas"
                              :rules="{ required: true, integer: true }"
                              v-slot="validationContext"
                            >
                              <b-form-group :id="`hours-${accrual.item.idConcept}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                                <b-form-input :id="`accrual-hours-${accrual.item.idConcept}`" v-model="accrual.item.hours"
                                placeholder="Horas *"
                                :state="getValidationState(validationContext)"
                                ></b-form-input>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                          <b-col v-if="accrual.item.requirePercentage" :md="checkSize(accrual)">
                            <validation-provider
                              name="Porcentaje"
                              :rules="{ required: true, integer: true }"
                              v-slot="validationContext"
                            >
                              <b-form-group :id="`percent-${accrual.item.idConcept}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                                <b-form-input :id="`accrual-percent-${accrual.item.idConcept}`" v-model="accrual.item.percentage"
                                placeholder="Porcentaje *"
                                :state="getValidationState(validationContext)"
                                ></b-form-input>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                          <b-col v-if="accrual.item.requireValue" :md="checkSize(accrual)">
                            <validation-provider
                              name="Valor"
                              :rules="{ required: true, integer: true }"
                              v-slot="validationContext"
                            >
                              <b-form-group :id="`value-${accrual.item.idConcept}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                                <b-form-input :id="`accrual-value-${accrual.item.idConcept}`" v-model="accrual.item.value"
                                placeholder="Valor *"
                                :state="getValidationState(validationContext)"
                                ></b-form-input>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </template>
                        <template #cell(actions)="accrual">
                          <b-col v-show="!conceptsCannotBeErased.includes(accrual.item.idConcept)" md="1" align-self="center">
                            <a-button @click="removeConcept(accrual.item, 'accruals')" type="deafault">
                              <i class="fa fa-trash text-danger" />
                            </a-button>
                          </b-col>
                        </template>
                      </b-table>
                      <b-row>
                        <b-col md="5">
                          <RequiredFields/>
                        </b-col>
                        <b-col md="4">
                            <h5>
                                Total: {{ currencyFormat(payrollData.totals.totalsAccruals) }}
                            </h5>
                          </b-col>
                      </b-row>
                    </div>
                  </template>
                </a-tab-pane>
                <a-tab-pane key="3" tab="Deducciones">
                  <template>
                    <div class="px-4" fluid>
                      <b-row v-show="deductionsSelector.length > 1">
                        <b-col cols="9" md="7">
                          <b-form-group id="deductions" label="Deducciones" label-for="deductions">
                            <b-form-select v-model="deductionCreated"
                            :options="deductionsSelector" required
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col class="pl-2" cols="2" md="3" align-self="end">
                          <b-button variant="primary" class="my-3 mx-2" @click="removeSelectedOption('deductions')">Agregar</b-button>
                        </b-col>
                      </b-row>
                      <b-table id="table-periods-payrolls" striped hover :fields="columns"
                        :items="payrollData.deductions" head-variant="light" responsive>
                        <template #cell(inputs)="deduction">
                          <b-col v-if="deduction.item.requireDays" :md="checkSize(deduction)">
                            <validation-provider
                              name="Días"
                              :rules="{ required: true, integer: true }"
                              v-slot="validationContext"
                            >
                              <b-form-group :id="`days-${deduction.item.idConcept}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                                <b-form-input :id="`deduction-days-${deduction.item.idConcept}`" v-model="deduction.item.days"
                                placeholder="Días *"
                                :state="getValidationState(validationContext)"
                                ></b-form-input>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                          <b-col v-if="deduction.item.requireHours" :md="checkSize(deduction)">
                            <validation-provider
                              name="Horas"
                              :rules="{ required: true, integer: true }"
                              v-slot="validationContext"
                            >
                              <b-form-group :id="`hours-${deduction.item.idConcept}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                                <b-form-input :id="`deduction-hours-${deduction.item.idConcept}`" v-model="deduction.item.hours"
                                placeholder="Horas *"
                                :state="getValidationState(validationContext)"
                                ></b-form-input>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                          <b-col v-if="deduction.item.requirePercentage" :md="checkSize(deduction)">
                            <validation-provider
                              name="Porcentaje"
                              :rules="{ required: true, integer: true }"
                              v-slot="validationContext"
                            >
                              <b-form-group :id="`percent-${deduction.item.idConcept}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                                <b-form-input :id="`deduction-percent-${deduction.item.idConcept}`" v-model="deduction.item.percentage"
                                placeholder="Porcentaje *"
                                :state="getValidationState(validationContext)"
                                ></b-form-input>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                          <b-col v-if="deduction.item.requireValue" :md="checkSize(deduction)">
                            <validation-provider
                              name="Valor"
                              :rules="{ required: true, integer: true }"
                              v-slot="validationContext"
                            >
                              <b-form-group :id="`value-${deduction.item.idConcept}`" class="mb-0" :invalid-feedback="validationContext.errors[0]">
                                <b-form-input :id="`deduction-value-${deduction.item.idConcept}`" v-model="deduction.item.value"
                                placeholder="Valor *"
                                :state="getValidationState(validationContext)"
                                ></b-form-input>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </template>
                        <template #cell(actions)="deduction">
                          <b-col v-show="!conceptsCannotBeErased.includes(deduction.item.idConcept)" md="1" align-self="center">
                            <a-button @click="removeConcept(deduction.item, 'deductions')" type="deafault">
                              <i class="fa fa-trash text-danger" />
                            </a-button>
                          </b-col>
                        </template>
                      </b-table>
                      <b-row>
                        <b-col md="5">
                          <RequiredFields/>
                        </b-col>
                        <b-col md="4">
                            <h5>
                                Total: {{ currencyFormat(payrollData.totals.totalsDeductions) }}
                            </h5>
                          </b-col>
                      </b-row>
                    </div>
                  </template>
                </a-tab-pane>
            </a-tabs>
        </b-col>
      </b-row>
      <!-- Footer -->
      <template #modal-footer>
        <b-button @click="$bvModal.hide('modal-payroll')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
        <div v-show="action === 'editPayrollDocument'">
            <b-button variant="primary" @click="save()">
                Guardar
            </b-button>
        </div>
        <div v-show="action === 'createAdjustmentNote'" @click="create()">
            <b-button variant="primary" >
                Crear
            </b-button>
        </div>
      </template>
    </b-modal>
</template>

<script>
import apiClient2 from '@/services/axios/v2.js'
import HeaderCompany from '@/components/custom/payroll/HeaderCompany.vue'
import RequiredFields from '@/components/custom/form/RequiredFields.vue'
import _ from 'lodash'
import Swal from 'sweetalert2'
import moment from 'moment'
import { currencyFormatPesos } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 8000,
  timerProgressBar: true,
  color: '#595c97',
  width: '600px',
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'ModalCreateEditPayroll',
  components: {
    HeaderCompany,
    RequiredFields,
  },
  props: {
    idPayroll: Number,
    action: String, // createAdjustmentNote, editPayrollDocument
  },
  data() {
    return {
      titleModal: 'Editar',
      colorAsterisco: '#4b7cf3',
      showAddAccrualForm: false,
      showAddDeductionForm: false,
      activeKey: '1',
      conceptsCannotBeErased: [1, 3, 4], // Identificador del devengado salario [GLOBAL]
      isPaymentMethodWithBank: false,
      payrollData: {
        consecutive: null,
        payStartDate: '',
        payEndDate: '',
        payDate: '',
        employee: {
          id: null,
          idPaymentMethod: '',
          idBank: null,
          idBankAccountType: null,
          bankAccountNumber: '',
        },
        accruals: [],
        deductions: [],
        totals: {},
      },
      columns: [
        {
          label: 'Nombre',
          key: 'name',
          tdClass: 'align-middle',
          thStyle: { width: '40%' },
        },
        {
          label: 'Valor',
          key: 'inputs',
          thClass: 'text-center',
        },
        {
          label: 'Acciones',
          key: 'actions',
          tdClass: 'align-middle',
        },
      ],
      payrollDataCopy: {},
      accrualsSelector: [],
      accruals: [],
      accrualCreated: null,
      deductionsSelector: [],
      deductions: [],
      deductionCreated: null,
      paymentMethods: [],
      banks: [],
      bankAccountTypes: [],
      conceptsToRemove: [],
      conceptsToAdd: [],
      paymentMethodsWithoutBank: [
        '20',
        '23',
        '25',
        '26',
        '92',
        '10',
        '71',
        '1',
        '8',
        '24',
        '34',
        '24',
        '34',
        '48',
        '49',
        '50',
        '51',
        '52',
        '53',
        '60',
        '61',
        '62',
        '63',
        '64',
        '65',
        '66',
        '67',
        '70',
        '74',
        '75',
        '76',
        '77',
        '78',
        '91',
        '93',
        '94',
        '95',
        '96',
        '97',
        '98',
        'ZZZ',
      ],
      valuesUpdated: [], // Arreglo que me permite identificar si hubieron valores editados de los conceptos
      datesChanges: {}, // Objeto que guarda las fechas que hayan cambiado para guardar
      dataEmployeeChanges: {}, // Objeto que guarda los cambios del método de pago del empleado
    }
  },
  created() {
    // Trae los métodos de pago
    apiClient2.get('payment-methods').then((res) => {
      const { data } = res
      if (data.success) {
        const { data: paymentMethods } = data
        this.paymentMethods = paymentMethods.map((p) => ({ value: p.id, text: p.name }))
      }
    }).catch((err) => {
      console.log(err)
    })
    // Trae los tipos de cuenta bancaria
    apiClient2.get('bank-account-types').then((res) => {
      const { data } = res
      if (data.success) {
        const { data: bankAccountTypes } = data
        this.bankAccountTypes = bankAccountTypes.map((p) => ({ value: p.id, text: p.name }))
      }
      this.bankAccountTypes.unshift({ value: null, text: 'Seleccione una opción' })
    }).catch((err) => {
      console.log(err)
    })
    // Trae los bancos
    apiClient2.get('banks').then((res) => {
      const { data } = res
      if (data.success) {
        const { data: banks } = data
        this.banks = banks.map((p) => ({ value: p.id, text: p.name }))
      }
      this.banks.unshift({ value: null, text: 'Seleccione una opción' })
    }).catch((err) => {
      console.log(err)
    })
  },
  watch: {
    idPayroll: function(newIdPayroll, oldIdPayroll) {
      // Se ejecuta cuando la propiedad 'name' del padre cambia
      this.idPayroll = newIdPayroll
      this.getPayroll()
        .then(() => this.getAccruals())
        .then(() => this.getDeductions())
        .then(() => {})
        .catch((error) => {
          console.error('Ha ocurrido un error:', error)
        })
    },
    action: function(newAction, oldAction) {
      // Se ejecuta cuando la propiedad 'lastname' del padre cambia
      this.action = newAction
      this.titleModal = this.action === 'createAdjustmentNote' ? 'Crear Nota de Ajuste Remplazar' : 'Editar'
    },
    'payrollData.employee.idPaymentMethod' () {
      if (!this.paymentMethodsWithoutBank.includes(this.payrollData.employee.idPaymentMethod.trim())) {
        // Agrega banco, tipo de cuenta bancaria y número de cuenta al formulario.
        this.isPaymentMethodWithBank = true
      } else {
        this.isPaymentMethodWithBank = false
      }
    },
  },
  methods: {
    currencyFormat: function (money) {
      return currencyFormatPesos(money)
    },
    getPayroll() {
      return new Promise((resolve, reject) => {
        // Trae la información de la nómina o nota de ajuste
        apiClient2.get(`payrolls/${this.idPayroll}`).then((res) => {
          const { data } = res
          if (data.success) {
            const { data: payroll } = data;
            ['payStartDate', 'payEndDate', 'payDate', 'consecutive', 'idPayroll', 'accruals', 'deductions', 'totals'].forEach((k) => {
              this.payrollData[k] = payroll[k]
            })
            this.payrollData.employee = payroll.employee
            this.payrollDataCopy = JSON.parse(JSON.stringify(this.payrollData))
          }
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getAccruals() {
      return new Promise((resolve, reject) => {
        // Trae los devengados
        apiClient2.get('/concepts?conceptType=accrual').then((res) => {
          const { data } = res
          if (data.success) {
            const { data: accruals } = data
            this.accrualsSelector = accruals
              .filter(a => !this.payrollData.accruals.find(ac => ac.idConcept === a.id))
              .map(a => ({
                value: a.id,
                text: a.name !== '' ? a.name : a['conceptType.name'],
              }))
            this.accruals = accruals
          }
          this.accrualsSelector.unshift({ value: null, text: 'Seleccione una opción' })
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getDeductions() {
      return new Promise((resolve, reject) => {
        // Trae las deducciones
        apiClient2.get('/concepts?conceptType=deduction').then((res) => {
          const { data } = res
          if (data.success) {
            const { data: deductions } = data
            this.deductionsSelector = deductions
              .filter(d => !this.payrollData.deductions.find(dc => dc.idConcept === d.id))
              .map(d => ({
                value: d.id,
                text: d.name !== '' ? d.name : d['conceptType.name'],
              }))
            this.deductions = deductions
          }
          this.deductionsSelector.unshift({ value: null, text: 'Seleccione una opción' })
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
    checkSize(item) {
      const properties = ['requireDays', 'requireHours', 'requireValue', 'requirePercentage']
      let size = 9
      for (const property of properties) {
        if (item[property]) {
          size -= 1
        }
      }
      return size
    },
    removeSelectedOption(conceptType) {
      const idConceptSelected = conceptType === 'accruals' ? 'accrualCreated' : 'deductionCreated'
      // Busca los datos completos del concepto seleccionado
      const dataConceptSelected = this[conceptType].find((c) => c.id === this[idConceptSelected])
      if (this[idConceptSelected] !== null) {
        // Elimina el concepto del selector
        this[conceptType + 'Selector'] = this[conceptType + 'Selector'].filter((a) => a.value !== this[idConceptSelected])
      }
      const concept = {
        days: null,
        hours: null,
        value: null,
        percentage: null,
        idConcept: this[idConceptSelected],
        idPayrollConcept: null,
        name: dataConceptSelected.name !== '' ? dataConceptSelected.name : dataConceptSelected['conceptType.name'],
        idConceptType: dataConceptSelected.idConceptType,
        requireValue: dataConceptSelected['conceptType.requireValue'],
        requireDays: dataConceptSelected['conceptType.requireDays'],
        requireHours: dataConceptSelected['conceptType.requireHours'],
        requirePercentage: dataConceptSelected['conceptType.requirePercentage'],
        isEdit: dataConceptSelected['conceptType.isEdit'],
        isRecreate: dataConceptSelected['conceptType.isRecreate'],
        conceptType: dataConceptSelected['conceptType.conceptType'],
      }
      this.payrollData[conceptType].push(concept)
      this.conceptsToAdd.push(concept)
      this[idConceptSelected] = null
    },
    removeConcept(concept, conceptType) {
      const idRow = concept.idConceptType + concept.idConcept
      this.payrollData[conceptType] = this.payrollData[conceptType].filter((a) => {
        const idRow2 = a.idConceptType + a.idConcept
        if (idRow !== idRow2) {
          console.log(a)
          return a
        }
      })
      // Remueve el concepto de la lista de conceptos a agregar
      this.conceptsToAdd = this.conceptsToAdd.filter((ca) => ca.idConcept !== concept.idConcept)
      // Agrega el devengado registrado a la lista de conceptos a remover
      if (concept.idPayrollConcept !== null) {
        this.conceptsToRemove.push(concept)
      }
      // Agrega el concepto al selector
      this[conceptType + 'Selector'].push({
        value: concept.idConcept,
        text: concept.name,
      })

      // Actualiza el total
      this.updateTotal(conceptType)
    },
    updateTotal(keyConcept) {
      if (keyConcept !== 'accruals' && keyConcept !== 'deductions') {
        throw new Error('keyConcept must accruals o deductions')
      }
      const totalsKey = keyConcept === 'accruals' ? 'totalsAccruals' : 'totalsDeductions'
      this.payrollData.totals[totalsKey] = this.payrollData[keyConcept].reduce((acc, concept) => {
        return acc + Number(concept.value)
      }, 0)
      this.payrollData.totals.totalPayment = Number(this.payrollData.totals.totalsAccruals) - Number(this.payrollData.totals.totalsDeductions)
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    deleteConcepts() {
      // Elimina conceptos
      return new Promise((resolve, reject) => {
        if (this.conceptsToRemove.length > 0) {
          const deletePromises = this.conceptsToRemove.map(concept =>
            apiClient2.delete(`/payrolls/${this.idPayroll}/concepts/${concept.idPayrollConcept}`),
          )

          Promise.all(deletePromises)
            .then(results => {
              const success = results.every(result => result.data.success)
              results.forEach((r) => {
                const { data } = r
                if (data.success) {
                  this.conceptsToRemove = this.conceptsToRemove.filter((cr) => cr.idConcept !== data.data.idConcept)
                  const key = data.data.conceptType === 'accrual' ? 'accruals' : 'deductions'
                  this.payrollDataCopy[key] = this.payrollDataCopy[key].filter((p) => p.idConcept !== data.data.idConcept)
                }
              })
              if (success) {
                this.conceptsToRemove = []
                resolve()
              } else {
                reject(new Error('No se pudo eliminar algún concepto.'))
              }
            })
            .catch(err => {
              console.log(err)
              reject(err)
            })
        } else {
          resolve() // Si no hay conceptos para eliminar, resuelve la promesa externa inmediatamente
        }
      })
    },
    createConcepts() {
      return new Promise((resolve, reject) => {
        if (this.conceptsToAdd.length > 0) {
          apiClient2.post(`/payrolls/${this.idPayroll}/concepts`, this.conceptsToAdd.map((ca) => {
            return {
              idConcept: ca.idConcept,
              ...(ca.value && { value: Number(ca.value) }),
              ...(ca.days && { days: Number(ca.days) }),
              ...(ca.hours && { hours: Number(ca.hours) }),
              ...(ca.percentage && { percentage: Number(ca.percentage) }),
            }
          })).then((res) => {
            const { data } = res
            if (data.success) {
              // alert('Agregación exitosa!')
              // Agrego los conceptos a sus copias
              const concepts = _.concat(this.accruals, this.deductions)
              data.data.forEach((d) => {
                const concept = concepts.find((c) => c.id === d.idConcept)
                const key = concept['conceptType.conceptType'] === 'accrual' ? 'accruals' : 'deductions'
                this.payrollDataCopy[key].push({
                  days: d.days,
                  hours: d.hours,
                  value: d.value,
                  percentage: d.percentage,
                  idConcept: d.idConcept,
                  idPayrollConcept: d.id,
                  idConceptType: concept.idConceptType,
                  isEdit: concept['conceptType.isEdit'],
                  isRecreate: concept['conceptType.isRecreate'],
                  name: concept['conceptType.name'],
                  requireDays: concept['conceptType.requireDays'],
                  requireHours: concept['conceptType.requireHours'],
                  requirePercentage: concept['conceptType.requirePercentage'],
                  requireValue: concept['conceptType.requireValue'],
                  conceptType: concept['conceptType.conceptType'],
                })
                // Actualizo el idPayrollConcept de la data del form
                const conceptForm = this.payrollData[key].find((c) => c.idConcept === d.idConcept)
                conceptForm.idPayrollConcept = d.id
              })
              resolve()
              this.conceptsToAdd = []
            }
          }).catch((err) => {
            // El devengado no se agrego y hay datos que corregir
            reject(err)
            console.log('Error al agregar el devengado', err)
          })
        } else {
          resolve() // Si no hay conceptos para agregar, resuelve la promesa externa inmediatamente
        }
      })
    },
    editConcepts() {
      return new Promise((resolve, reject) => {
        const conceptsOriginals = _.concat(this.payrollDataCopy.accruals, this.payrollDataCopy.deductions)
        const conceptsForm = _.concat(this.payrollData.accruals, this.payrollData.deductions)
        const promises = []

        conceptsOriginals.forEach((originalConcept, index) => {
          const concept = conceptsForm.find(c => c.idConcept === originalConcept.idConcept)
          if (concept) {
            ['days', 'hours', 'value', 'percentage'].forEach((field) => {
              if (Object.prototype.hasOwnProperty.call(concept, field) && concept[field] !== null) {
                concept[field] = Number(concept[field])
              }
            })
            const values = _.differenceWith(_.toPairs(concept), _.toPairs(originalConcept), _.isEqual)
            if (values.length !== 0) {
              const valuesObj = _.fromPairs(values)
              this.valuesUpdated.push({
                concept: originalConcept,
                values: valuesObj,
              })
              promises.push(apiClient2.patch(`/payrolls/${this.idPayroll}/concepts/${originalConcept.idPayrollConcept}`, valuesObj))
            }
          }
        })

        Promise.all(promises)
          .then((results) => {
            results.forEach((res, index) => {
              const { data } = res
              const { data: dataConcept } = data
              // const originalConcept = conceptsOriginals[index]
              const keyConcept = dataConcept.conceptType === 'accrual' ? 'accruals' : 'deductions'
              if (data.success) {
                const indexConcept = this.payrollDataCopy[keyConcept].findIndex(a => a.idConcept === dataConcept.idConcept)
                this.payrollDataCopy[keyConcept][indexConcept] = dataConcept
                this.valuesUpdated = this.valuesUpdated.filter((v) => v.concept.idConcept !== dataConcept.idConcept)
                // alert(JSON.stringify(dataConcept) + ' index concept ' + indexConcept)
              }
            })
            resolve()
          })
          .catch((error) => {
            console.error(error)
            reject(error)
          })
      })
    },
    editDates() {
      return new Promise((resolve, reject) => {
        if (Object.keys(this.datesChanges).length !== 0) {
          apiClient2.patch(`/payrolls/${this.idPayroll}`, this.datesChanges).then((res) => {
            const { data } = res
            if (data.success) {
              // Agrego los datos que modifico a la copia
              this.payrollDataCopy = { ...this.payrollDataCopy, ...this.datesChanges }
              this.datesChanges = {}
              resolve()
            }
          })
            .catch((err) => {
              reject(err)
            })
        } else {
          resolve()
        }
      })
    },
    editEmployee() {
      return new Promise((resolve, reject) => {
        if (Object.keys(this.dataEmployeeChanges).length !== 0) {
          apiClient2.patch(`/employees/${this.payrollData.employee.id}`, this.dataEmployeeChanges).then((res) => {
            const { data } = res
            if (data.success) {
              // Agrego los datos que modifico a la copia
              this.payrollDataCopy.employee = { ...this.payrollDataCopy.employee, ...this.dataEmployeeChanges }
              this.dataEmployeeChanges = {}
              resolve()
            }
          })
            .catch((err) => {
              reject(err)
            })
        } else {
          resolve()
        }
      })
    },
    checkIfChangesEmployee() {
      const employeeOrig = {}
      const employeeForm = {}
      const keysEmployee = ['idPaymentMethod', 'idBank', 'idBankAccountType', 'bankAccountNumber']
      keysEmployee.forEach((f) => {
        employeeOrig[f] = this.payrollDataCopy.employee[f]
        employeeForm[f] = this.payrollData.employee[f]
      })

      const emploOrigClone = _.clone(employeeOrig)
      const emploFormClone = _.clone(employeeForm)

      const valuesEmplo = _.differenceWith(_.toPairs(emploFormClone), _.toPairs(emploOrigClone), _.isEqual)
      if (valuesEmplo.length !== 0) {
        this.dataEmployeeChanges = _.clone(_.fromPairs(valuesEmplo))
      } else {
        this.dataEmployeeChanges = {}
      }
    },
    save() {
      this.checkIfChangesEmployee()
      // ----- Dates -------
      const datesOriginals = {}
      const dateForm = {}
      const keys = ['payStartDate', 'payEndDate', 'payDate']
      keys.forEach((f) => {
        datesOriginals[f] = this.payrollDataCopy[f]
        dateForm[f] = this.payrollData[f]
      })

      const dateOrigClone = _.clone(datesOriginals)
      const dateFormClone = _.clone(dateForm)

      const values = _.differenceWith(_.toPairs(dateFormClone), _.toPairs(dateOrigClone), _.isEqual)
      if (values.length !== 0) {
        this.datesChanges = _.clone(_.fromPairs(values))
      } else {
        this.datesChanges = {}
      }
      const conceptsOriginals = _.concat(this.payrollDataCopy.accruals, this.payrollDataCopy.deductions)
      const conceptsForm = _.concat(this.payrollData.accruals, this.payrollData.deductions)
      conceptsOriginals.forEach((originalConcept, index) => {
        const concept = conceptsForm.find(c => c.idConcept === originalConcept.idConcept)
        if (concept) {
          ['days', 'hours', 'value', 'percentage'].forEach((field) => {
            if (Object.prototype.hasOwnProperty.call(concept, field) && concept[field] !== null) {
              concept[field] = Number(concept[field])
            }
          })
          const values = _.differenceWith(_.toPairs(concept), _.toPairs(originalConcept), _.isEqual)
          if (values.length !== 0) {
            const valuesObj = _.fromPairs(values)
            this.valuesUpdated.push({
              concept: originalConcept,
              values: valuesObj,
            })
          }
        }
      })
      if (this.conceptsToRemove.length === 0 &&
      this.conceptsToAdd.length === 0 &&
      this.valuesUpdated.length === 0 &&
      Object.keys(this.datesChanges).length === 0 &&
      Object.keys(this.dataEmployeeChanges).length === 0
      ) {
        Toast.fire({
          icon: 'warning',
          title: '¡No has modificado nada!',
        })
        return false
      }

      this.deleteConcepts()
        .then(() => this.editDates())
        .then(() => this.editEmployee())
        .then(() => this.createConcepts())
        .then(() => this.editConcepts())
        .then(() => {
          Toast.fire({
            icon: 'success',
            title: 'Modificación exitosa',
          })
          this.$emit('refreshData')
          this.$refs['modal-payroll'].hide()
        })
        .catch(err => console.log(err))
      // Creación
      // if (this.conceptsToAdd.length > 0) {
      //   apiClient2.post(`/payrolls/${this.idPayroll}/concepts`, this.conceptsToAdd.map((ca) => {
      //     return {
      //       idConcept: ca.idConcept,
      //       ...(ca.value && { value: Number(ca.value) }),
      //       ...(ca.days && { days: Number(ca.days) }),
      //       ...(ca.hours && { hours: Number(ca.hours) }),
      //       ...(ca.percentage && { percentage: Number(ca.percentage) }),
      //     }
      //   })).then((res) => {
      //     const { data } = res
      //     if (data.success) {
      //       alert('Agregación exitosa!')
      //       this.conceptsToAdd = []
      //     }
      //   }).catch((err) => {
      //     // El devengado no se agrego y hay datos que corregir
      //     console.log('Error al agregar el devengado', err)
      //   })
      // }
      // Edición

      // Obtiene los conceptos que estan disponibles para editar

      // Conceptos cargados desde el back
      // const conceptsOriginals = _.concat(this.payrollDataCopy.accruals, this.payrollDataCopy.deductions)
      // // Conceptos que estan renderizados en el html
      // const conceptsForm = _.concat(this.payrollData.accruals, this.payrollData.deductions)
      // const valuesUpdated = []
      // console.log(conceptsForm)
      // for (let index = 0; index < conceptsOriginals.length; index++) {
      //   const concept = conceptsForm.find(c => c.idConcept === conceptsOriginals[index].idConcept)
      //   if (concept) {
      //     ['days', 'hours', 'value', 'percentage'].forEach((field) => {
      //       if (Object.prototype.hasOwnProperty.call(concept, field) && concept[field] !== null) {
      //         concept[field] = Number(concept[field])
      //       }
      //     })
      //     console.log('CONCEPTO FORM', concept)
      //     console.log('CONCEPTO ORIGINAL', conceptsOriginals[index])
      //     // Comparo que datos cambiaron
      //     const values = _.differenceWith(_.toPairs(concept), _.toPairs(conceptsOriginals[index]), _.isEqual)
      //     console.log('VALUES ANTES', values)
      //     if (values.length !== 0) {
      //       valuesUpdated.push(values)
      //       // Hay cambios 😁
      //       apiClient2.patch(`/payrolls/${this.idPayroll}/concepts/${conceptsOriginals[index].idPayrollConcept}`, _.fromPairs(values)).then((res) => {
      //         const { data } = res
      //         let indexConcept = -1
      //         const keyConcept = conceptsOriginals[index].conceptType === 'accrual' ? 'accruals' : 'deductions'
      //         // Respuesta exitosa ✅
      //         if (data.success) {
      //           console.log('CONCEPTOS ORIGINALES', conceptsOriginals)
      //           // Refresco el objeto original
      //           indexConcept = this.payrollDataCopy[keyConcept].findIndex((a) => a.idConcept === conceptsOriginals[index].idConcept)
      //           console.log(this.payrollDataCopy[keyConcept][indexConcept])
      //           console.log('VALUES ADD', values)
      //           console.log('LO QUE DEBERIA AGREGAR', _.assign({}, conceptsOriginals[indexConcept], _.fromPairs(values)))
      //           this.payrollDataCopy[keyConcept][indexConcept] = _.assign({}, conceptsOriginals[indexConcept], _.fromPairs(values))
      //           console.log(this.payrollDataCopy[keyConcept][indexConcept])
      //           alert(JSON.stringify(conceptsOriginals[index]) + 'index concept' + indexConcept)
      //         }
      //       }).catch((err) => {
      //         console.log(err)
      //       })
      //       console.log('VALUES', values)
      //     }
      //   }
      // }
      // console.log('CONCEPTOS A REMOVER', this.conceptsToRemove)
      // console.log('CONCEPTOS A AGREGAR', this.conceptsToAdd)
      // console.log('DATOS CAMBIADOS', values)
    },
    createAdjustmentNote() {
      return new Promise((resolve, reject) => {
        const data = {
          payStartDate: moment(this.payrollData.payStartDate).utc().format('YYYY-MM-DD'),
          payEndDate: moment(this.payrollData.payEndDate).utc().format('YYYY-MM-DD'),
          payDate: moment(this.payrollData.payDate).utc().format('YYYY-MM-DD'),
          typePayroll: 'Nota de Ajuste Remplazar',
          accruals: this.payrollData.accruals.map((a) => {
            return {
              idConcept: a.idConcept,
              ...((a.percentage !== null && a.percentage !== '') && { percentage: Number(a.percentage) }),
              ...((a.value !== null && a.value !== '') && { value: Number(a.value) }),
              ...((a.hours !== null && a.hours !== '') && { hours: Number(a.hours) }),
              ...((a.days !== null && a.days !== '') && { days: Number(a.days) }),
            }
          }),
          deductions: this.payrollData.deductions.map((a) => {
            return {
              idConcept: a.idConcept,
              ...((a.percentage !== null && a.percentage !== '') && { percentage: Number(a.percentage) }),
              ...((a.value !== null && a.value !== '') && { value: Number(a.value) }),
              ...((a.hours !== null && a.hours !== '') && { hours: Number(a.hours) }),
              ...((a.days !== null && a.days !== '') && { days: Number(a.days) }),
            }
          }),
        }
        const idPayroll = this.payrollData.idPayroll === null ? this.idPayroll : this.payrollData.idPayroll
        apiClient2.post(`payrolls/${idPayroll}/adjustment-note`, data).then((res) => {
          const { data } = res
          if (data.success) {
            Toast.fire({
              icon: 'success',
              title: data.message,
            })
            this.$emit('refreshData')
            this.$refs['modal-payroll'].hide()
            resolve()
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
    create() {
      // Crea una nota de ajuste remplazar
      if (this.action !== 'createAdjustmentNote') {
        throw new Error('¡action must be createAdjustmentNote!')
      }
      this.checkIfChangesEmployee()
      this.editEmployee()
        .then(this.createAdjustmentNote())
        .then()
        .catch(err => console.log(err))
    },
  },
}

</script>
